import { render, staticRenderFns } from "./StatisticClaimRoadsFull.vue?vue&type=template&id=3e320fae&scoped=true&"
import script from "./StatisticClaimRoadsFull.vue?vue&type=script&lang=js&"
export * from "./StatisticClaimRoadsFull.vue?vue&type=script&lang=js&"
import style0 from "./StatisticClaimRoadsFull.vue?vue&type=style&index=0&id=3e320fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e320fae",
  null
  
)

export default component.exports
import {QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
